import api from '../utils/api'

// export const createCompany = async (company) => {
// }

export const getCompanies = async (filter) =>{
    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(filter ? `/companies${filter}`:`/companies`).then((response) => {
            return response.data
        })

        return data


    } catch (error) {

        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return error;
        
    }
}

export const getCompanyById = async (companyId) =>{
    try {

        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(`/companies/${companyId}`).then((response) => {
            return response.data
        })

        return data
        
    } catch (error) {

        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return error;      
    }
}

const GmoService = {
    // createGmo,
    getCompanies,
    getCompanyById,
}

export default GmoService